import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import SolutionPurchaseModal from "../Solutions/SolutionPurchaseModal";
import {
  SolutionType,
  useGetSolutionByUuidQuery,
} from "../store/slices/settingsSlice";

export default function SolutionPurchaseRouteModal() {
  const { solutionUuid } = useParams<{ solutionUuid: string }>();
  const navigate = useNavigate();
  const solutionResponse = useGetSolutionByUuidQuery(
    { uuid: solutionUuid || "" },
    { skip: !solutionUuid }
  );
  const solution = solutionResponse.data as SolutionType | undefined;
  const closeModal = () => navigate("/library/solutions/available");

  return (
    <Modal show onHide={closeModal} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Purchase Solution</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="bg-solution">
          {solutionResponse.isLoading ? (
            <div className="d-flex justify-content-center p-5">
              <div className="spinner-border" role="status" />
            </div>
          ) : solution ? (
            <SolutionPurchaseModal
              solution={solution}
              onPurchased={(purchasedSolution) =>
                navigate(
                  `/library/solutions/purchased/${purchasedSolution.Uuid}/deploy`,
                  { replace: true }
                )
              }
            />
          ) : (
            <div className="alert alert-danger m-0">
              Unable to load this solution.
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
